export function PdfView({ src }: { src: string }) {
  return (
    <div className="h-full min-h-[24rem] w-full overflow-hidden rounded-md">
      <embed src={src} type="application/pdf" className="h-full min-h-[24rem] w-full" />
    </div>
  );
}
